import React, { useState,useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Button,
  TextField,
  Typography,
  Paper,
  Grid,
  IconButton,
  Dialog,
  DialogContent,
  CircularProgress
} from "@mui/material";
import { AddCircle, RemoveCircle } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import apiClient from "./api/apiClient"; // Axios instance
import { useParams } from "react-router-dom";

const MeetingRequest = () => {
//  const { id } = useParams();
//  const [title, setTitle] = useState("");
//  const [inviteeName, setInviteeName] = useState("");
  const [dateOptions, setDateOptions] = useState([""]); // array of date-time options
  const navigate = useNavigate();
  const location = useLocation();
  const { title,inviteeName, inviteeEmail, inviteeMobilePhoneNumber, id,bankVerificationId } = location.state || {};
  const [isProcessing, setIsProcessing] = useState(false);
  useEffect(() => {
    if (id) {
      apiClient.get(`/meetingschedulers/${id}`).then((res) => {
//        setTitle(res.data.title);
//        setInviteeName(res.data.inviteeName);
//        setInviteeEmail(res.data.inviteeEmail);
//        setInviteeMobilePhoneNumber(res.data.inviteeEmail);
        setDateOptions(res.data.proposedDates || [""]);
      }).catch((err) => console.error(err));
    }
  }, [id]);
  const handleAddOption = () => {
    if (dateOptions.length < 3) {
      setDateOptions([...dateOptions, ""]);
    }
  };

  const handleRemoveOption = (index) => {
    const updated = [...dateOptions];
    updated.splice(index, 1);
    setDateOptions(updated);
  };

  const handleDateChange = (index, value) => {
    const updated = [...dateOptions];
    updated[index] = value;
    setDateOptions(updated);
  };

/*  const handleSubmit = async (e) => {
    e.preventDefault();
    const initiatorId = localStorage.getItem("userId");

    try {
      const response = await apiClient.post("/meetingschedulers", {
        title,
        inviteeName,
        inviteeEmail,
        initiatorId,
        proposedDates: dateOptions.filter((d) => d), // only send filled ones
      });

      console.log("Meeting request sent:", response.data);
      navigate("/meetings");
    } catch (error) {
      console.error("Error sending meeting request:", error);
      alert("Failed to send meeting request.");
    }
  };*/
/*  const handleSubmit = async (e) => {
    e.preventDefault();
    const initiatorId = localStorage.getItem("userId");
    setIsProcessing(true);
    try {
      let response;
      if (id) {
        // UPDATE existing meeting
        try{
          response = await apiClient.put(`/meetingschedulers/${id}`, {
            title,
            inviteeName,
            inviteeEmail,
            initiatorId,
            proposedDates: dateOptions.filter((d) => d),
          });
        }catch(err){
          console.log("Error updating meeting schedulers")
        }finally{
          setIsProcessing(false);
        }

      } else {
        // CREATE new meeting

        let payload = {
          title,
          inviteeName,
          inviteeEmail,
          initiatorId,
          proposedDates: dateOptions.filter((d) => d),
        }
        const url = bankVerificationId
        ? `/meetingschedulers?bankVerificationId=${bankVerificationId}`
        : `/meetingschedulers`;
        try{
          response = await apiClient.post(url, payload);
        }catch(err){

        }finally{
          setIsProcessing(false)
        }

      }
  
      console.log("Meeting request saved:", response.data);
      navigate(-1);
    } catch (error) {
      console.error("Error saving meeting request:", error);
      alert("Failed to save meeting request.");
    }
  };*/

  /*const handleSubmit = async (e) => {
    e.preventDefault();
    const initiatorId = localStorage.getItem("userId");
    const accessToken = localStorage.getItem("googleAccessToken");
    if (!accessToken) {
      alert("Please link your Google Calendar first.");
      return;
    }
  
    setIsProcessing(true);
    try {
      // STEP 1️⃣: Cleanup old scheduled meetings
      const scheduledRes = await apiClient.get(`/meetingschedulers`, {
        params: { status: "SCHEDULED", userId: initiatorId },
      });
      const scheduledMeetings = scheduledRes.data || [];
  
      for (const meet of scheduledMeetings) {
        // Delete previously blocked calendar event (if stored)
        if (meet.googleEventId) {
          await fetch(
            `https://www.googleapis.com/calendar/v3/calendars/primary/events/${meet.googleEventId}`,
            {
              method: "DELETE",
              headers: { Authorization: `Bearer ${accessToken}` },
            }
          );
          console.log(`Deleted old scheduled event ${meet.googleEventId}`);
        }
      }
  
      // STEP 2️⃣: Save the meeting request to backend
      const payload = {
        title,
        inviteeName,
        inviteeEmail,
        initiatorId,
        proposedDates: dateOptions.filter((d) => d),
      };
      const url = bankVerificationId
        ? `/meetingschedulers?bankVerificationId=${bankVerificationId}`
        : `/meetingschedulers`;
  
      const response = id
        ? await apiClient.put(`/meetingschedulers/${id}`, payload)
        : await apiClient.post(url, payload);
  
      const meetingData = response.data;
      console.log("Meeting saved:", meetingData);
  
      // STEP 3️⃣: Block calendar slots for proposed dates
      for (let dateTime of dateOptions.filter(Boolean)) {
        const start = new Date(dateTime);
        const end = new Date(start.getTime() + 30 * 60000); // 30 minutes later
  
        const eventPayload = {
          summary: title || "Bank Verification Meeting",
          description: `Meeting with ${inviteeName}`,
          start: { dateTime: start.toISOString(), timeZone: "Asia/Kolkata" },
          end: { dateTime: end.toISOString(), timeZone: "Asia/Kolkata" },
          status: "tentative",
        };
  
        const res = await fetch(
          "https://www.googleapis.com/calendar/v3/calendars/primary/events",
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(eventPayload),
          }
        );
  
        const createdEvent = await res.json();
        console.log("Created calendar event:", createdEvent.id);
  
        // Optional: Save Google Event ID in backend (for deletion later)
//        await apiClient.put(`/meetingschedulers/${meetingData.id}/googleEvent`, {
//          googleEventId: createdEvent.id,
//        });
      }
  
      alert("✅ Meeting request saved and calendar blocked successfully!");
      navigate(-1);
  
    } catch (error) {
      console.error("Error saving meeting or updating calendar:", error);
      alert("❌ Failed to save meeting or update Google Calendar.");
    } finally {
      setIsProcessing(false);
    }
  };*/
  const handleSubmit = async (e) => {
    e.preventDefault();
    const initiatorId = localStorage.getItem("userId");
    const accessToken = localStorage.getItem("googleAccessToken");
    setIsProcessing(true);
    let googleEnabled = false;

    if (!accessToken) {
      try {
        const verifyRes = await fetch(
          "https://www.googleapis.com/oauth2/v1/tokeninfo?access_token=" + accessToken
        );
        if (verifyRes.ok) {
          googleEnabled = true;
        } else {
          console.warn("⚠️ Google token invalid or expired. Skipping calendar sync.");
        }
      } catch (err) {
        console.warn("⚠️ Google Calendar check failed:", err);
      }
    }else {
      console.log("ℹ️ No Google Calendar linked. Proceeding without calendar integration.");
    }
  
  
    try {
      // Fetch existing status (if updating)
      let existingStatus = null;
      if (id) {
        const existingRes = await apiClient.get(`/meetingschedulers/${id}`);
        existingStatus = existingRes.data?.status?.toUpperCase();
      }
  
      // STEP 1️⃣: Only if status is "SCHEDULED" → delete old events
      if (googleEnabled && existingStatus === "SCHEDULED") {
        const scheduledRes = await apiClient.get(`/meetingschedulers`, {
          params: { status: "SCHEDULED", userId: initiatorId },
        });
        const scheduledMeetings = scheduledRes.data || [];
  
        for (const meet of scheduledMeetings) {
          if (meet.googleEventId) {
            await fetch(
              `https://www.googleapis.com/calendar/v3/calendars/primary/events/${meet.googleEventId}`,
              {
                method: "DELETE",
                headers: { Authorization: `Bearer ${accessToken}` },
              }
            );
            console.log(`🗑️ Deleted old scheduled event: ${meet.googleEventId}`);
          }
        }
      }
  
      // STEP 2️⃣: Save or update the meeting scheduler entry
      const payload = {
        title,
        inviteeName,
        inviteeEmail,
        initiatorId,
        proposedDates: dateOptions.filter((d) => d),
      };
  
      const url = bankVerificationId
        ? `/meetingschedulers?bankVerificationId=${bankVerificationId}`
        : `/meetingschedulers`;
  
      const response = id
        ? await apiClient.put(`/meetingschedulers/${id}`, payload)
        : await apiClient.post(url, payload);
  
      const meetingData = response.data;
      console.log("✅ Meeting saved:", meetingData);
  
      // STEP 3️⃣: Decide how many dates to block in Google Calendar
      if(googleEnabled){
        const datesToBlock =
          existingStatus === "SCHEDULED"
            ? [meetingData.scheduledDate] // only the scheduled date
            : dateOptions.filter(Boolean); // all proposed dates
    
        for (let dateTime of datesToBlock) {
          if (!dateTime) continue;
          const start = new Date(dateTime);
          const end = new Date(start.getTime() + 30 * 60000);
    
          const eventPayload = {
            summary: title || "Bank Verification Meeting",
            description: `Meeting with ${inviteeName}`,
            start: { dateTime: start.toISOString(), timeZone: "Asia/Kolkata" },
            end: { dateTime: end.toISOString(), timeZone: "Asia/Kolkata" },
            status: "tentative",
          };
          try{
            const res = await fetch(
              "https://www.googleapis.com/calendar/v3/calendars/primary/events",
              {
                method: "POST",
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(eventPayload),
              }
            );
    
            const createdEvent = await res.json();
            console.log("📅 Created calendar event:", createdEvent.id);
    
          // Optional: save Google event id back to backend
          // await apiClient.put(`/meetingschedulers/${meetingData.id}/googleEvent`, {
          //   googleEventId: createdEvent.id,
          // });
          }catch(err){
            console.warn("⚠️ Failed to create calendar event:", err);
          }
        }
      }else{
        console.log("🕓 Google Calendar not available — skipping event creation.");
      }
  
      alert("✅ Meeting request saved and calendar blocked successfully!");
      navigate(-1);
  
    } catch (error) {
      console.error("❌ Error saving meeting or updating calendar:", error);
      alert("Failed to save meeting or update Google Calendar.");
    } finally {
      setIsProcessing(false);
    }
  };
  
  

  return (
    <>
    <Paper style={{ padding: 20, maxWidth: 650, margin: "auto", marginTop: 40 }}>
      <Typography variant="h6" gutterBottom>
        Meeting Request
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Meeting Title"
              fullWidth
              required
              editable="false"
              value={title}
//              onChange={(e) => setTitle(e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Invitee Name"
              fullWidth
              required
              value={inviteeName}
              editable="false"
//              onChange={(e) => setInviteeName(e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Invitee Email"
              type="email"
              fullWidth
              required
              editable="false"
              value={inviteeEmail}
//              onChange={(e) => setInviteeEmail(e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Invitee Mobile Phone Number"
              type="text"
              fullWidth
              required
              editable="false"
              value={inviteeMobilePhoneNumber}
//              onChange={(e) => setInviteeMobilePhoneNumber(e.target.value)}
            />
          </Grid>          

          <Grid item xs={12}>
            <Typography variant="subtitle1">Proposed Dates & Times</Typography>
            {dateOptions.map((date, index) => (
              <Grid container spacing={1} key={index} alignItems="center">
                <Grid item xs={10}>
                  <TextField
                    type="datetime-local"
                    fullWidth
                    required
                    InputLabelProps={{ shrink: true }}
                    value={date}
                    onChange={(e) => handleDateChange(index, e.target.value)}
                  />
                </Grid>
                <Grid item xs={2}>
                  {dateOptions.length > 1 && (
                    <IconButton
                      color="secondary"
                      onClick={() => handleRemoveOption(index)}
                    >
                      <RemoveCircle />
                    </IconButton>
                  )}
                  {index === dateOptions.length - 1 && dateOptions.length < 3 && (
                    <IconButton color="primary" onClick={handleAddOption}>
                      <AddCircle />
                    </IconButton>
                  )}
                </Grid>
              </Grid>
            ))}
          </Grid>

          <Grid item xs={12} style={{ textAlign: "right" }}>
            <Button type="submit" variant="contained" color="primary">
              Send Meeting Request
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
      {/* 🔹 Modal shown during processing */}
      <Dialog open={isProcessing}>
      <DialogContent
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          p: 4,
        }}
      >
        <CircularProgress />
        <Typography>Processing your response...</Typography>
      </DialogContent>
    </Dialog>    
    </>
  );
};

export default MeetingRequest;
